import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";
import Cookies from "js-cookie";

const post = async (token, path, body, fallback) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(body),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : fallback;
  if (!res.ok) {
    throw new Error(data?.message || `Request failed with status ${res.status}`);
  }
  return data;
};

export const getBusinessUsers = async (token, requesterId, mantisBusinessId) => {
  const data = await post(
    token,
    "/backoffice/mantisBusiness/users/list",
    { requesterId, mantisBusinessId },
    { users: [] }
  );
  return data.users || [];
};

export const createBusinessUser = async (
  token,
  requesterId,
  mantisBusinessId,
  userData
) => post(
  token,
  "/backoffice/mantisBusiness/users/create",
  { requesterId, mantisBusinessId, userData },
  {}
);

export const updateBusinessUser = async (
  token,
  requesterId,
  mantisBusinessId,
  mantisBusinessUserId,
  userData
) => post(
  token,
  "/backoffice/mantisBusiness/users/update",
  { requesterId, mantisBusinessId, mantisBusinessUserId, userData },
  {}
);

export const deleteBusinessUser = async (
  token,
  requesterId,
  mantisBusinessId,
  mantisBusinessUserId
) => post(
  token,
  "/backoffice/mantisBusiness/users/delete",
  { requesterId, mantisBusinessId, mantisBusinessUserId },
  {}
);

export const getBusinessUserPermissions = async (token, requesterId) => {
  const data = await post(
    token,
    "/backoffice/getAllPermissions",
    { requesterId },
    { permissions: [] }
  );
  return data.permissions || [];
};
